<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Collector 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="6">
          <b-form-group label-cols=1 label="Filter ">
              <b-row>
                <b-col class="pr-1" cols="7"><b-form-input v-model="filter.collector_name" @keyup.13.native="refresh()" placeholder="Name"></b-form-input></b-col>
                <b-col class="pl-1" cols="5"><b-form-input v-model="filter.crewnik" @keyup.13.native="refresh()" placeholder="ID"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="3">
                <b-button variant="success" size="sm" @click="refresh()"><i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(iklan)="data">
          <span v-if="data.item.iklan==1"><i class="fa fa-check "></i></span>
        </template>
        <template v-slot:cell(koran)="data">
          <span v-if="data.item.koran==1"><i class="fa fa-check "></i></span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
            <div slot="header">Collector - Add/Edit Form </div>
                  <b-input-group>
                        <b-input-group-prepend><label>Collector Name</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.collector_name" :state="!$v.frmdata.collector_name.$error"></b-form-input>
                  </b-input-group>
                  <b-input-group >
                        <b-input-group-prepend><label>Employee ID</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.crewinfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuCrewShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Collector Area</label></b-input-group-prepend>
                      <b-form-checkbox class="ml-3 mt-2 mr-2" v-model="frmdata.iklan" value="1" unchecked-value="0"><b>Collector Iklan</b></b-form-checkbox>
                      <b-form-checkbox class="ml-3 mt-2 mr-2" v-model="frmdata.koran" value="1" unchecked-value="0"><b>Collector Koran</b></b-form-checkbox>
                    </b-input-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>

      </b-col>
    </b-row>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true" :lazy="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import lkuCrew from "../lookup/lkuCrewlazzy";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuCrew},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        collector_name: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      lkuCrewShow: false,
      lkuCrewData: [],
      showList:true,
      showForm:false,
      frmdata:{crewnik: '', iklan:0, isPaket:0, crewkey:'',JenisKomp:'', rumus:'', SifatKomp:'', koran:'', IdFrm1721:'' },
      tblData: {
        tablename:'collector',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'collector_name',
        sortDesc: true
      },
      filter:{},
      YesNo :   [{ value: 0, text: 'YES' }, { value: 1, text: 'NO' }],
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            label: "No.",
            thStyle: "width:50px",
            sortable: true
          },
          {
            key: "collector_name",
            label: "Collector Name",
            sortable: true
          },
          {
            key: "crewnik",
            label: "Employee ID",
            sortable: true
          },
          {
            key: "iklan",
            label: "Iklan",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "koran",
            label: "Koran",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {
    onSelectLkuCrew: function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.frmdata.crewinfo = lkuData.selected.crewname.trim() + ' | ' + lkuData.selected.crewnik.trim();
        this.frmdata.crewkey = lkuData.selected.crewkey;
        this.frmdata.collector_name = lkuData.selected.crewname.trim();
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str='';
      if (this.filter.crewnik){
        str = 'crewnik=%' + encodeURIComponent(this.filter.crewnik)+'%';
      }
      if (this.filter.collector_name){
        str += str ? '&' : '';
        str = str + 'collector_name=' + encodeURIComponent(this.filter.collector_name)+'%';
      }
      this.tblData.customQuery=str;

      const list = await crud.list(this.tblData);      
      return list;
    },
    clearFilter(ctx) {
      this.tblData.collector_name = "";
      this.tblData.crewnik = "";
      // this.refresh();
    },    
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.collector_id;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
    this.frmdata.iklan=this.frmdata.iklan || '0';                   
    this.frmdata.koran= this.frmdata.koran || '0';              

        if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'collector', 
                     key:this.frmdata.idlama, 
                     data:{collector_name:this.frmdata.collector_name, 
                        koran:this.frmdata.koran,                   
                        iklan:this.frmdata.iklan,                   
                        crewkey:this.frmdata.crewkey}
                      });
              } else {
                await crud.insert(
                  { tablename:'collector',                      
                     data:{collector_name:this.frmdata.collector_name, 
                        koran:this.frmdata.koran,                   
                        iklan:this.frmdata.iklan,                   
                        crewkey:this.frmdata.crewkey}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'collector', key:this.model.collector_id});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
